module.exports = __webpack_public_path__ + "af69081d658c83372a38bd122d488304.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/chipotle_2023_chart.png
// module id = 1654
// module chunks = 0